import axios from "axios";

// Create an Axios instance using process.env for the base URL
const apiCaller = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL, // Using environment variable
  headers: {
    "Content-Type": "application/json",
  },
});

// Intercept requests before they are sent (optional)
apiCaller.interceptors.request.use(
  (config) => {
    const { requiresAuth = true } = config; // Custom flag to determine if auth is needed
    config.headers["x-api-key"] = `${process.env.REACT_APP_X_API_KEY}`;

    if (requiresAuth) {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercept responses after they are received (optional)
apiCaller.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle error responses, like token expiration or network errors
    if (error.response && error.response.status === 401) {
    }
    return Promise.reject(error);
  }
);

// Function to make GET requests with optional authorization
export const getData = async (endpoint, requiresAuth = true) => {
  try {
    const response = await apiCaller.get(endpoint, { requiresAuth });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

// Function to make POST requests with optional authorization
export const postData = async (endpoint, data, requiresAuth = true) => {
  try {
    const response = await apiCaller.post(endpoint, data, { requiresAuth });
    return response.data;
  } catch (error) {
    console.error("Error posting data:", error);
    throw error;
  }
};

export const putData = async (endpoint, data = {}, requiresAuth = true) => {
  try {
    const response = await apiCaller.put(endpoint, data, { requiresAuth });
    return response.data;
  } catch (error) {
    console.error("Error putting data:", error);
    throw error;
  }
};

export const deleteData = async (endpoint, requiresAuth = true) => {
  try {
    const response = await apiCaller.delete(endpoint, { requiresAuth });
    return response.data;
  } catch (error) {
    console.error("Error putting data:", error);
    throw error;
  }
};

export const deleteDoc = async (endpoint) => {
  try {
    const response = await apiCaller.delete(endpoint);
    return response;
  } catch (error) {
    const axiosError = error;
    const response = {};
    response.message = axiosError.response?.data?.message || axiosError.message;
    response.status = axiosError.response?.status || 500; // Default to 500 if no specific status code
    return response;
  }
};

export const verifyNote = async (endpoint) => {
  try {
    const response = await apiCaller.get(endpoint);
    return response;
  } catch (error) {
    const axiosError = error;
    const response = {};
    response.message = axiosError.response?.data?.message || axiosError.message;
    response.status = axiosError.response?.status || 500; // Default to 500 if no specific status code
    return response;
  }
};

export const verifyNoteOTPContent = async (endpoint, data) => {
  try {
    const response = await apiCaller.post(endpoint, data);
    return response;
  } catch (error) {
    const axiosError = error;
    const response = {};
    response.message = axiosError.response?.data?.message || axiosError.message;
    response.status = axiosError.response?.status || 500; // Default to 500 if no specific status code
    return response;
  }
};

// You can add more functions for PUT, DELETE, etc.
